import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
// @ts-nocheck
import React from "react";
import { useMutation } from "@apollo/client";
import { Grid, FormTable, FormDialog, FormSnackBar } from "../../mui";
import { ContentActions, ContentTypography } from "../content";
import FormBar from "./FormBar";
import FormStatistics from "./FormStatistics";
import FormCards from "./FormCards";
import { ManagePoolSchemasDialog, ManagePoolFiltersDialog } from "../dialogs";
import { ContentType, UserPermission, FeatureType, status, FormFieldType } from "../../../utils/enums";
import { ListsSelect } from "../selects";
import { ContentKanban } from "../content";
import constants from "../../../utils/constants";
import { MANAGE_LIST_POOLS } from "../../../containers/ListContainer";
import ManageModel from "../../Pools/ManageModel";
const FormContent = ({ pool = false, organizationModelId = null, modelName = "", category = "", headers = [], data = [], count = 0, page = 0, defaultView = ContentType.Table, rowsPerPage = 0, rowsPerPageOptions = constants.ROWS_PER_PAGE.map((pages) => parseInt(pages)), order = constants.DEFAULT_ORDER, defaultOrder = constants.DEFAULT_ORDER, orderBy = "createdAt", search = null, setActionDialogState = () => null, editMutation = () => null, refetch = () => null, handleExport = () => null, handleImport = () => null, notIncludedFields = [], fields = [], permissions = [], defaultSchema = null, }) => {
    const [openModelDialog, setModelDialog] = React.useState(false);
    const [openSchemaDialog, setSchemaDialog] = React.useState(false);
    const [openFiltersDialog, setFiltersDialog] = React.useState(false);
    const [openListsDialog, setListsDialog] = React.useState(false);
    const [listId, setListId] = React.useState(null);
    const [snackBar, setSnackBar] = React.useState({
        open: false,
        message: "",
        type: "",
    });
    const [rows, setRows] = React.useState(data?.map((d) => ({
        ...d,
        edited: false,
        selected: false,
        editable: true,
    })));
    const [view, setView] = React.useState(ContentType.Table);
    const [kanbanField, setKanbanField] = React.useState(constants.DEFAULT_KANBAN_FIELD);
    const [kanbanFieldOptions, setKanbanFieldOptions] = React.useState(Object.keys(status));
    const [manageListPools] = useMutation(MANAGE_LIST_POOLS);
    React.useEffect(() => setView(defaultView), [defaultView]);
    React.useEffect(() => setRows(data?.map((d) => ({
        ...d,
        edited: false,
        selected: false,
        editable: true,
    }))), [data]);
    const editRow = (event, row) => {
        let temp = row;
        if (event?.target?.type === FormFieldType.Checkbox.toLowerCase()) {
            temp[event.target.name] = event.target.checked;
        }
        else if (event.target.name === "selected") {
            temp.selected = event.target.checked;
        }
        else {
            temp[event.target.name] = event.target.value;
        }
        let newTableData = rows;
        if (newTableData.length === 1) {
            setRows([temp]);
        }
        else {
            let tableDataIndex = newTableData.indexOf(newTableData.find((tableRow) => tableRow.id === temp.id));
            const editedTableData = [
                ...newTableData.slice(0, tableDataIndex),
                temp,
                ...newTableData.slice(tableDataIndex + 1),
            ];
            setRows((prev) => [...editedTableData]);
        }
    };
    const deleteSelectedRows = () => {
        let newTableData = rows;
        let tableDataIndex = row.id;
        newTableData.splice(tableDataIndex, 1);
        setRows((prev) => [...newTableData]);
    };
    const handleSelectAllClick = (event) => {
        if (event.target.checked) {
            const selectedRows = rows.map((n) => ({
                ...n,
                selected: true,
            }));
            setRows(selectedRows);
        }
        else {
            const selectedRows = rows.map((n) => ({
                ...n,
                selected: false,
            }));
            setRows(selectedRows);
        }
    };
    const manageListPoolsDialog = () => {
        if (listId) {
            const data = rows?.map((row) => row.selected && {
                name: row.name,
                editable: true,
            });
            manageListPools({
                variables: {
                    listId,
                    data,
                },
                onCompleted: () => setSnackBar({
                    open: true,
                    message: `Updated List successfully!!`,
                    type: "success",
                }),
                onError: () => setSnackBar({
                    open: true,
                    message: `${getContent("errorMessage")}`,
                    type: "error",
                }),
            });
            setListsDialog(false);
        }
    };
    const manageActionPermitted = permissions?.find((permission) => permission?.feature === FeatureType.ContentsManage)?.permission ===
        UserPermission.Manage;
    const schemaManageActionPermitted = permissions?.find((permission) => permission?.feature === FeatureType.SchemasManage)?.permission ===
        UserPermission.Manage;
    const usageManageActionPermitted = permissions?.find((permission) => permission?.feature === FeatureType.UsageManager)?.permission ===
        UserPermission.Manage;
    const contentView = () => {
        switch (view) {
            case ContentType.Table:
                return (_jsx(Grid, { container: true, children: _jsx(Grid, { item: true, xs: 12, children: _jsx(FormTable, { handleSelectAllVisible: manageActionPermitted, headers: headers, rows: rows, fields: fields, editRow: manageActionPermitted ? editRow : null, handleSelectAllClick: manageActionPermitted ? handleSelectAllClick : null, handleRowVisible: true, handleRowAction: setActionDialogState, onSubmitCheck: editMutation, count: count, rowsPerPage: rowsPerPage, rowsPerPageOptions: rowsPerPageOptions, page: page, order: order, orderBy: orderBy, defaultOrder: defaultOrder, refetch: refetch, notIncludedFields: notIncludedFields }) }) }));
            case ContentType.Grid:
                return (_jsx(FormCards, { rows: rows, handleRowAction: setActionDialogState, onSubmitCheck: editMutation, count: count, rowsPerPage: rowsPerPage, rowsPerPageOptions: rowsPerPageOptions, page: page, order: order, orderBy: orderBy, defaultOrder: defaultOrder, refetch: refetch }));
            case ContentType.Kanban:
                return (_jsx(ContentKanban, { isDragDisabled: !manageActionPermitted, rows: rows, handleRowAction: setActionDialogState, onSubmitCheck: editMutation, count: count, rowsPerPage: rowsPerPage, rowsPerPageOptions: rowsPerPageOptions, page: page, order: order, orderBy: orderBy, defaultOrder: defaultOrder, refetch: refetch, fieldName: kanbanField, options: kanbanFieldOptions }));
            default:
                return null;
        }
    };
    return (_jsxs(_Fragment, { children: [_jsx(FormSnackBar, { snackBar: snackBar, setSnackBar: setSnackBar }), openSchemaDialog && (_jsx(ManagePoolSchemasDialog, { organizationModelId: organizationModelId, open: openSchemaDialog, onDialogChange: () => setSchemaDialog(!openSchemaDialog), setSnackBar: setSnackBar })), openModelDialog && (_jsx(FormDialog, { open: openModelDialog, setOpen: () => setModelDialog(!openModelDialog), title: _jsx(ContentTypography, { field: "manageDataPoolLabel" }), actions: _jsx(ContentActions, { onClose: () => setModelDialog(!openModelDialog) }), children: _jsx(ManageModel, { category: category, modelName: modelName, setSnackBar: setSnackBar }) })), openFiltersDialog && (_jsx(ManagePoolFiltersDialog, { organizationModelId: organizationModelId, open: openFiltersDialog, setSnackBar: setSnackBar, onDialogChange: () => setFiltersDialog(!openFiltersDialog) })), openListsDialog && (_jsx(FormDialog, { open: openListsDialog, setOpen: () => setListsDialog(!openListsDialog), title: _jsx(ContentTypography, { field: "selectListLabel" }), actions: _jsx(ContentActions, { onClose: () => setListsDialog(!openListsDialog), onSave: manageListPoolsDialog }), children: _jsx(ListsSelect, { value: listId, onChange: (event) => setListId(event.target.value) }) })), _jsxs(Grid, { container: true, spacing: 2, children: [_jsx(Grid, { item: true, xs: 12, children: _jsx(FormStatistics, { organizationModelId: organizationModelId, modelName: modelName, permissions: permissions, setSnackBar: setSnackBar }) }), _jsx(Grid, { item: true, xs: 12, children: _jsx(FormBar, { pool: pool, someSelected: rows.some((r) => r.selected), someSelectedLabel: _jsx(ContentTypography, { field: "addToListLabel" }), someSelectedFunctionality: manageActionPermitted ? () => setListsDialog(true) : null, setActionDialogState: manageActionPermitted ? setActionDialogState : null, openFiltersDialog: manageActionPermitted ? openFiltersDialog : null, setFiltersDialog: manageActionPermitted ? setFiltersDialog : null, openSchemaDialog: schemaManageActionPermitted ? openSchemaDialog : null, setSchemaDialog: schemaManageActionPermitted ? setSchemaDialog : null, openModelDialog: manageActionPermitted ? openModelDialog : null, setModelDialog: manageActionPermitted ? setModelDialog : null, deleteFunctionality: manageActionPermitted ? deleteSelectedRows : null, handleExport: usageManageActionPermitted ? handleExport : null, handleImport: usageManageActionPermitted ? handleImport : null, view: view, view: view, setView: setView, search: search, onSearch: (value) => refetch?.({
                                filters: { search: value },
                            }), refetch: refetch, defaultSchema: defaultSchema }) }), rows?.length > 0 ? (_jsx(Grid, { item: true, xs: 12, children: contentView() })) : (_jsx(Grid, { item: true, xs: 12, children: _jsx(ContentTypography, { color: "secondar", m: 8, align: "center", field: "noDataDescription" }) }))] })] }));
};
export default FormContent;
